import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import { getComplaintById, updateComplaintStatus } from '../../../services/complaintService';
import { Complaint } from '../../../types/complaint';
import { ComplaintStatus } from '../../../types/enums';
import formStyles from '../trainees/TraineeForm.module.css';
//import sharedStyles from '../../SharedPageStyles.module.css';
import pageStyles from '../../Page.module.css';

const ViewComplaintPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const complaintId = Number(id);

  const [complaint, setComplaint] = useState<Complaint | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (!complaintId) return;
    getComplaintById(complaintId)
      .then(setComplaint)
      .catch(() => {
        toast.error('فشل في جلب بيانات الشكوى.');
        navigate('/admin/complaints/list');
      });
  }, [complaintId, navigate]);

  const handleStatusChange = (newStatus: ComplaintStatus) => {
    setIsSubmitting(true);
    const promise = updateComplaintStatus(complaintId, newStatus);
    toast.promise(promise, {
      loading: 'جاري تحديث الحالة...',
      success: (updatedComplaint) => {
        setComplaint(updatedComplaint);
        setIsSubmitting(false);
        return 'تم تحديث حالة الشكوى بنجاح!';
      },
      error: (err) => {
        setIsSubmitting(false);
        return err.response?.data?.message || 'فشل في تحديث الحالة.';
      },
    });
  };

  if (!complaint) return <div>جاري التحميل...</div>;

  return (
    <div className={formStyles.pageContainer}>
      <div className={formStyles.formContainer}>
        <h2 className={formStyles.title}>تفاصيل الشكوى رقم: {complaint.id}</h2>
        
        <div className={formStyles.detailsSection}>
          <p><strong>تاريخ التقديم:</strong> {new Date(complaint.created_at).toLocaleString('ar-EG')}</p>
          <p><strong>الحالة الحالية:</strong> <span style={{fontWeight: 'bold'}}>{complaint.status}</span></p>
          <hr/>
          <h4>بيانات المشتكي</h4>
          <p><strong>الاسم:</strong> {complaint.complainant_name}</p>
          <p><strong>البريد الإلكتروني:</strong> {complaint.email}</p>
          <p><strong>الهاتف:</strong> {complaint.phone}</p>
          <hr/>
          <h4>المحامي المشتكى عليه</h4>
          <p><strong>الاسم:</strong> {complaint.lawyer?.name || 'N/A'}</p>
          <hr/>
          <h4>نص الشكوى</h4>
          <p style={{ whiteSpace: 'pre-wrap', background: '#f9f9f9', padding: '1rem', borderRadius: '4px' }}>
            {complaint.complaint_text}
          </p>
        </div>

        <div className={`${formStyles.buttonContainer} ${formStyles.fullWidth}`} style={{ marginTop: '1rem', borderTop: '1px solid #eee', paddingTop: '1rem' }}>
          <Link to="/admin/complaints/list" className={formStyles.cancelButton}>العودة للقائمة</Link>
          {complaint.status !== ComplaintStatus.UNDER_REVIEW && (
            <button onClick={() => handleStatusChange(ComplaintStatus.UNDER_REVIEW)} disabled={isSubmitting} className={pageStyles.actionButton} style={{color: 'blue'}}>
              تحديد كـ "قيد المراجعة"
            </button>
          )}
          {complaint.status !== ComplaintStatus.RESOLVED && (
            <button onClick={() => handleStatusChange(ComplaintStatus.RESOLVED)} disabled={isSubmitting} className={pageStyles.actionButton} style={{color: 'green'}}>
              تحديد كـ "تم حلها"
            </button>
          )}
          {complaint.status !== ComplaintStatus.REJECTED && (
            <button onClick={() => handleStatusChange(ComplaintStatus.REJECTED)} disabled={isSubmitting} className={pageStyles.actionButton} style={{color: 'red'}}>
              تحديد كـ "مرفوضة"
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ViewComplaintPage;
